/** Human-readable labels for Flow portal user activity log action codes. */
export const PORTAL_ACTIVITY_ACTION_LABELS: Record<string, string> = {
  email_verification_bypass: 'Email verification bypassed',
};

export function formatPortalActivityActionLabel(action: string): string {
  const explicitLabel = PORTAL_ACTIVITY_ACTION_LABELS[action];
  if (explicitLabel) {
    return explicitLabel;
  }

  return action
    .split(/[._]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
